module.exports = __webpack_public_path__ + "img/tweeter.400dc885.png";